import React from 'react';
import { NavLink } from 'react-router-dom';
//import './styles/css2.css';
import './styles/css1.css';
import { withRouter } from 'react-router'

export default class Login extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      email_address: '',
      password: ''
    };

    this.update_email_address = this.update_email_address.bind(this);
    this.update_password = this.update_password.bind(this);

  }

  componentDidMount() {
     console.log(window.globalEmail)
     console.log( window.globalPassword )
     try {
        if (typeof window.globalEmail !== 'undefined'){
        this.setState({ email_address: window.globalEmail });
        document.getElementById('email_address').value = window.globalEmail;
        console.log(window.globalEmail)
     }
     if (typeof window.globalPassword !== 'undefined'){
          this.setState({ password:  window.globalPassword  });
          document.getElementById('password').value =  window.globalPassword
          console.log( window.globalPassword )
     }
     if (typeof this.props.location.path !== 'undefined'){
          this.setState({path: this.props.location.state.path})
          console.log(this.props.location.state.path)
     }
//     if (typeof this.props.location.email !== 'undefined'){
//        this.setState({ email_address: this.props.location.email });
//        document.getElementById('email_address').value = this.props.location.email;
//        console.log(this.props.location.email)
//     }
//     if (typeof this.props.location.password !== 'undefined'){
//          this.setState({ password: this.props.location.password });
//          document.getElementById('password').value = this.props.location.password
//          console.log(this.props.location.password)
//     }
//     if (typeof this.props.location.path !== 'undefined'){
//          this.setState({path: this.props.location.state.path})
//          console.log(this.props.location.state.path)
//     }

     } catch (e) {
     console.log('Error getting state login.js - 40')}
  }

  update_email_address(event) {
    this.setState({ email_address: event.target.value });
    //console.log(this.state.sn);
  }

    update_password(event) {
    this.setState({ password: event.target.value });
    //console.log(this.state.sn);
  }

  createCookie = (cookieName, cookieValue, time) => {
       let date = new Date()
       date.setTime(date.getTime() + (time*60*60*1000))
       document.cookie = cookieName + "=" + cookieValue + "; expires = " + date.toGMTString()
     }

  handleClick = () => {
    //console.log('click');
//    console.log(this.state.email_address);
//    console.log(this.state.password);


    if (this.state.email_address.length === 0  || this.state.password.length === 0){
      var fields = "";
      if (this.state.email_address.length === 0) {
        fields = "Email Address\n";
      }
       if (this.state.password.length === 0) {
        fields += "Password\n";
      }

      alert("The following fields are missing\n" + fields)
    } else {
      var xhr1 = new XMLHttpRequest()
      xhr1.addEventListener('load', () => {
        var data = JSON.parse(xhr1.responseText);//parse response text into data object
        //console.log("collage_map from MPS1: " + data.collage_map_mex);
//        console.log("response from server: " + data.result);
        if (data.result === "OK") {
          //alert("OK" + data.first_name)
//          console.log(this.state.email_address)
//          console.log(this.state.password)
          window.globalEmail = this.state.email_address;
          window.globalPassword = this.state.password;
          window.globalFirstName = data.first_name;
          window.globalLastName = data.last_name;
          this.createCookie("email", window.globalEmail, 1)
          this.createCookie("test_data", "this is test data", 1)
          if (window.globalPath == 'register'){
              this.props.history.push({
              pathname: '/register'
    //          state: {
    //          email: this.state.email_address,
    //          password: this.state.password,
    //          first_name: data.first_name,
    //          last_name: data.last_name}
              })
          }else{
               this.props.history.push({
               pathname: '/user_menu'
              })
          }


        } else {
          if (data.result === "NIGO") {
            alert("Email address or password is incorrect")
          }

        }
      })

      xhr1.open('POST', 'http://3.21.222.196:3035/login');//87 is considered unsafe by Chrome
      xhr1.setRequestHeader("Content-Type", "application/json");
      xhr1.send(JSON.stringify({
        email: this.state.email_address, password: this.state.password}));
    }
  }

  render() {

    return (
      <div className='container'>
        <div className="container4">
        <div className="header">
          <div className="menu1">
            <NavLink to="/" activeClassName="is-active" exact={true}>Home</NavLink>
          </div>
          <div className="menu2"><a href="/#setup">Setup</a></div>
          <div className="menu3"><NavLink to="/register" activeClassName="is-active" exact={true}>Register Your Device</NavLink></div>
          <div className="menu5"><NavLink to="/reporting_dashboard" activeClassName="is-active" exact={true}>Reports</NavLink></div>
          <div className="menu4"><NavLink to="/login" activeClassName="is-active" exact={true}>Login</NavLink></div>
        </div>
        <div className="row">
          <center>
            <div className="col-12 col-s-12">

              <div className="col-12 col-s-12">
                <img className="center_img2" src="argon_one_case2D_black_custom_blue.png" alt="" />
                <br></br>
                <p className="text_catch3"> Login</p>
                <table className="table1">
                  <tbody>
                    <tr>
                      <td className="form_text_left">
                        <div>Email:
                        </div>
                      </td>
                      <td className=""><input type="text" id="email_address" name="email_address" onChange={this.update_email_address}></input></td>
                    </tr>
                    <tr>
                      <td className="form_text_left">
                        <div>Password:
                        </div>
                      </td>
                      <td className=""><input type="password" id="password" name="password" onChange={this.update_password}></input></td>
                    </tr>


                  </tbody>
                </table>
                <center>
                  <br></br><br></br>
                  <button onClick={this.handleClick}>Login</button>
                 </center>
                <center>
                  <NavLink to="/create_account" activeClassName="is-active" exact={true}><p className="text_catch4">Or create account</p></NavLink>
                  <br></br><br></br><br></br>
                </center>
                
              </div>

            </div>
          </center>
          
        </div>
        
        <div className="footer">
        <br></br>
          <p className="text3, hidden">MJM Technologies, Inc.</p>
          <p className="text3, hidden">xxx-xxx-xxxx</p>
          <p className="text3">&copy; ApolloMusicPlayer.com</p>
          <p className="text3, hidden">&copy;2020 MJM Technologies, Inc.</p>
          <p className="text3">Pat. No. 11,232,469</p>
        <br></br>
        </div>
        </div>
      </div >
    );
  }
}